import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["icon", "field"];

  static UNSELECTED_CLASS = "primary-fill-gray-300";
  static HOVER_CLASS = "primary-fill-primary-300";
  static SELECTED_CLASS = "primary-fill-primary-600";

  preview(event) {
    if (event.currentTarget.disabled) return;

    this._fill(Number(event.currentTarget.dataset.value), this.constructor.HOVER_CLASS);
  }

  restore() {
    this._fill(Number(this.fieldTarget.value) || 0, this.constructor.SELECTED_CLASS);
  }

  select(event) {
    if (event.currentTarget.disabled) return;

    const value = Number(event.currentTarget.dataset.value);
    this.fieldTarget.value = value;
    this.fieldTarget.dispatchEvent(new Event("change", { bubbles: true }));
    this._fill(value, this.constructor.SELECTED_CLASS);
  }

  _fill(filledUpTo, filledClass) {
    const { UNSELECTED_CLASS, HOVER_CLASS, SELECTED_CLASS } = this.constructor;

    this.iconTargets.forEach((icon) => {
      const filled = Number(icon.dataset.value) <= filledUpTo;
      icon.classList.remove(UNSELECTED_CLASS, HOVER_CLASS, SELECTED_CLASS);
      icon.classList.add(filled ? filledClass : UNSELECTED_CLASS);
    });
  }
}
